/**
 * Portal deployment-environment helpers.
 *
 * DEV-only UI features should use this helper so all gating logic is
 * consistent across routes, drawer menus, and app-bar widgets.
 */

const DEV_HOSTNAMES = new Set([
    'localhost',
    '127.0.0.1',
    'smpservices-dev.eastus.cloudapp.azure.com',
]);

const normalizePortalEnv = (value) => (typeof value === 'string' ? value.trim().toLowerCase() : '');

/**
 * Returns true only when the portal is running in DEV.
 *
 * Priority:
 *  1) Runtime env var from server (window.__PORTAL_ENV__)
 *  2) Explicit build-time env var (REACT_APP_PORTAL_ENV)
 *  3) Hostname fallback for known deployments
 */
export const isDevPortalEnvironment = (
    locationHostname = window.location.hostname,
    configuredPortalEnv = process.env.REACT_APP_PORTAL_ENV,
    runtimePortalEnv = window.__PORTAL_ENV__
) => {
    const env = normalizePortalEnv(runtimePortalEnv) || normalizePortalEnv(configuredPortalEnv);
    if (env) {
        return env === 'dev' || env === 'development';
    }

    const hostname = normalizePortalEnv(locationHostname);
    if (!hostname) return false;
    if (DEV_HOSTNAMES.has(hostname)) return true;

    return hostname.startsWith('dev.') || hostname.includes('-dev.');
};
